<div class="image-carousel">
    <out-carousel timing="250ms ease" [showControls]="true" [showNavigation]="false">
        <!-- Button Prev -->
        <ng-container buttonPrev>
            <div class="">
                <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#links-open"></use></svg>
            </div>
        </ng-container>

        <!-- Button Next -->
        <ng-container buttonNext>
            <div class="">
                <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#rechts-open"></use></svg>
            </div>
        </ng-container>

        <ng-container items>
            <out-carousel-item class="image-carousel__image" *ngFor="let item of items">
                <img src="/assets/default-image-1x1.png" lazyLoad="/assets/shared{{ item.image }}" />
            </out-carousel-item>
        </ng-container>
    </out-carousel>
</div>
